import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionsLayout } from '@progress/kendo-angular-layout';
import readXlsxFile from 'read-excel-file';
import { FieldValidation, ImportData } from '../models/column-config.model';
import { commonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-build-import',
  templateUrl: './build-import.component.html',
  styleUrl: './build-import.component.scss'
})
export class BuildImportComponent {

  sheetContent: any[] = [];

  validationMsg: string[] = [];

  @Input() set setFieldValidationInput(fieldValidations: FieldValidation[]) {
    if (fieldValidations.length > 0) {
      this.fieldValidationInput = fieldValidations;
    }
  }

  @Output() contentValidated = new EventEmitter<ImportData>();

  fieldValidationInput!: FieldValidation[];
  constructor(private commonService: commonService){}

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Prevent default behavior
  }

  onDropSuccess(event: any): void {
    event.preventDefault(); // Prevent default behavior
    let files = event.dataTransfer?.files;

    let fileInputElement: any = document.getElementById("importFileUpload");

    let data = {
      target: {
        files: event.dataTransfer?.files
      }
    };

    if (event.dataTransfer?.files.length > 0) {
      this.addFile(event);
    }
  }

  async addFile(event: any) {
    let file = event.target.files[0];

    let object: any = null;
    let allData: any[] = [];
    readXlsxFile(file).then((rows: any) => {

      if(rows.length == 0){
        this.commonService.showNotificationMessage("Empty excel sheet uploaded", "error", "center");
      }

      if (rows.length > 1) {
        rows.forEach((row: any, index: number) => {
          if (index == 0) {
            object = row;
          }
          else {
            let data: any = {};
            Object.keys(object).map((x: any) => {
              let key = object[x];
              let keyField = this.fieldValidationInput.find((x: FieldValidation) => x.title == key);
              if (keyField) {
                if(keyField.dataType == "string"){
                  data[keyField.field] = row[x]?.toString() ?? "";
                }else{
                  data[keyField.field] = row[x];
                }
              }
            });

            allData.push(data);
          }
        });

        this.sheetContent = allData;
      }
      else{
        this.commonService.showNotificationMessage("No row data present in sheet", "error", "center");
      }
    });
  }

  validateData() {
    this.validationMsg = [];

    if (this.fieldValidationInput?.length > 0) {
      this.sheetContent.forEach((content: any, index: number) => {
        Object.keys(content).forEach(key => {

          let fieldValidation = this.fieldValidationInput.find((fieldInput: any) => fieldInput.title == key);
          if (fieldValidation) {
            if (this.isFieldRequiredValidate(content, key, fieldValidation)) {
              this.validationMsg.push(`Row No ${index + 1} - ${key} is required.`);
            }
            else if (this.isFieldMinMaxLengthValidate(content, key, fieldValidation, false)) {
              this.validationMsg.push(`Row No ${index + 1} - ${key} maximum length exceeded.`);
            }
            else if (this.isFieldMinMaxLengthValidate(content, key, fieldValidation, true)) {
              this.validationMsg.push(`Row No ${index + 1} - ${key} minimum length error.`);
            }
          }
        });
      });
    }

    let data: ImportData = {
      data: this.sheetContent,
      validationMsgs: this.validationMsg,
      cancel: false
    };

    this.contentValidated.emit(data);
  }

  isFieldRequiredValidate(data: any, key: string, fieldValidation: any) {
    if (fieldValidation.validations.find((validation: any) => validation == "required")) {
      return data[key] == undefined || data[key] == '' || data[key] == null;
    }

    return false;
  }

  isFieldMinMaxLengthValidate(data: any, key: string, fieldValidation: any, isMin: boolean) {
    let validationKey = isMin ? "minLength" : "maxLength";
    let validationIndex = fieldValidation.validations.findIndex((validation: any) => validation.includes(validationKey));
    if (validationIndex > -1) {
      let length = 0;
      let lengthSplit = fieldValidation.validations[validationIndex]?.split("=");

      if (lengthSplit.length == 2) {
        length = lengthSplit[1];
      }

      if (length > 0)
        return isMin ? data[key].length < length : data[key].length > length;
    }

    return false;
  }

  cancelUpload() {
    let data: ImportData = {
      data: [],
      validationMsgs: [],
      cancel: true
    };

    this.contentValidated.emit(data);
  }


}
